module.exports = __webpack_public_path__ + "img/5.c132491.png";